import { Auth } from 'aws-amplify';
import { fireGTM } from '../../gtm/gtmUtil';
import { logout_GTM } from '../../gtm/datalayers/utilDataLayers.json';

export const handleBackButton = async ({ gtmLocation }) => {
  fireGTM(logout_GTM, 'logout', gtmLocation);
  await Auth.signOut({ global: true });
};

// Prevent page reloading if the user selects the back button we \
// need to push at least two states onto the stack and then make sure to push \
// another state from our popstate handler.
export const onPopState = async (tenantName, allFunctions, event) => {
  window.history.replaceState(
    event.state,
    'Top 3 Page',
    `/${tenantName.toLowerCase()}/career-path/top-3`
  );
  window.history.pushState(
    event.state,
    'Top 3 Page',
    `/${tenantName.toLowerCase()}/career-path/top-3`
  );
};

export const setUpPageReloadingHandler = (
  currentState,
  tenantName,
  functionsToUse
) => {
  //  commenting this out instead of deleting because it's breaking things and doesn't really make sense
  //  but was probably here for a reason

  // window.history.pushState(
  //   currentState,
  //   'Push Initial State 1',
  //   `/${tenantName.toLowerCase()}/career-path/top-3`
  // );
  // window.history.pushState(
  //   currentState,
  //   'Push Initial State 2',
  //   `/${tenantName.toLowerCase()}/career-path/top-3`
  // );
  window.addEventListener('popstate', (event) =>
    onPopState(tenantName, functionsToUse, event)
  );
};
